import { Box, Tab, Tabs } from '@mui/material';
import { useStore } from 'mobx/StoreContext';
import { observer } from 'mobx-react-lite';
import {
  JobAssignStatus,
  JobQueueTableType,
} from 'pages/iPriseV2/common/enum/TeamUserRoles';
import CommonJobQueueTable from 'pages/iPriseV2/common/JobQueueTable';
import React from 'react';

import ColumnsSidebar from './ColumnsSidebar';

const JobQueueTable: React.FC = () => {
  const { recruiterJobQueueService } = useStore();
  const {
    subTab,
    newPage,
    newRowsPerPage,
    pendingPage,
    pendingRowsPerPage,
    submittedPage,
    submittedRowsPerPage,
    searchTerm,
    selectedSort,
    percentage,
  } = recruiterJobQueueService;

  const handleSubTabChange = (
    _event: React.SyntheticEvent,
    newValue: number,
  ) => {
    recruiterJobQueueService.setSubTab(newValue);
  };

  return (
    <Box className="table-container-with-sidebar">
      <Box className="table-main-content">
        <Box className="sub-tabs-container">
          <Box className="sub-tabs-wrapper">
            <Tabs
              value={subTab}
              onChange={handleSubTabChange}
              className="sub-tabs"
              variant="scrollable"
              allowScrollButtonsMobile
              TabIndicatorProps={{
                className: 'sub-tab-indicator',
              }}>
              <Tab label="New" className="sub-tab" />
              <Tab label="Pending" className="sub-tab" />
              <Tab label="Submitted for Review" className="sub-tab" />
            </Tabs>
          </Box>
        </Box>

        {subTab === 0 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.RECRUITER_NEW}
            status={JobAssignStatus.RECRUITER_ASSIGNED}
            queryKey="recruiter-job-postings-new"
            page={newPage}
            rowsPerPage={newRowsPerPage}
            onPageChange={(p) => recruiterJobQueueService.setNewPage(p)}
            onRowsPerPageChange={(r) =>
              recruiterJobQueueService.setNewRowsPerPage(r)
            }
            popperId="skills-popper-recruiter-new"
            selectedSort={selectedSort}
            searchTerm={searchTerm}
            percentage={percentage}
          />
        )}
        {subTab === 1 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.RECRUITER_PENDING}
            status={JobAssignStatus.RECRUITER_ACCEPTED}
            queryKey="recruiter-job-postings-pending"
            page={pendingPage}
            rowsPerPage={pendingRowsPerPage}
            onPageChange={(p) => recruiterJobQueueService.setPendingPage(p)}
            onRowsPerPageChange={(r) =>
              recruiterJobQueueService.setPendingRowsPerPage(r)
            }
            popperId="skills-popper-recruiter-pending"
            selectedSort={selectedSort}
            searchTerm={searchTerm}
            percentage={percentage}
          />
        )}
        {subTab === 2 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.RECRUITER_SUBMITTED}
            status={JobAssignStatus.READY_FOR_REVIEW}
            queryKey="recruiter-job-postings-submitted"
            page={submittedPage}
            rowsPerPage={submittedRowsPerPage}
            onPageChange={(p) => recruiterJobQueueService.setSubmittedPage(p)}
            onRowsPerPageChange={(r) =>
              recruiterJobQueueService.setSubmittedRowsPerPage(r)
            }
            popperId="skills-popper-recruiter-submitted"
            selectedSort={selectedSort}
            searchTerm={searchTerm}
            percentage={percentage}
          />
        )}
      </Box>
      <ColumnsSidebar />
    </Box>
  );
};

export default observer(JobQueueTable);
